import React from 'react';
import { Pressable, StyleSheet, View, TextInput, Image } from 'react-native';
import { launchImageLibrary } from 'react-native-image-picker';
import { ResponsiveImage } from '../ResponsiveImage';

const placeholderImage = require('assets/add_image.svg');
const linkIcon = require('assets/link.png');

const calculateSize = (url: string) => {
  const length = url.slice(url.indexOf(',')).length;
  return Math.ceil(length / 4) * 3;
};

export function ImagePicker({
  image,
  onImageChange,
  type = 'full',
  url = false,
}: {
  image?: string;
  onImageChange: (image: string, size?: number) => void;
  type?: string;
  url?: boolean;
}) {
  async function getImage() {
    if (url) return;
    const result = await launchImageLibrary({ mediaType: 'photo' });
    onImageChange(result.assets[0].uri, calculateSize(result.assets[0].uri));
  }

  return (
    <Pressable onPress={() => getImage()}>
      {url && (
        <View style={style.urlContainer}>
          <Image
            source={linkIcon}
            alt={'Link icon'}
            style={style.linkIcon}
            width={20}
            height={20}
            resizeMode="contain"
          />
          <TextInput
            value={image || ''}
            style={style.input}
            onChangeText={(value) => onImageChange(value)}
            placeholder="Image URL"
          />
        </View>
      )}
      <View style={type === 'icon' ? style.icon : style.image}>
        <ResponsiveImage
          uri={image ? image : url ? undefined : placeholderImage}
        />
      </View>
    </Pressable>
  );
}

const style = StyleSheet.create({
  image: {
    maxWidth: 400,
  },
  icon: {
    width: 40,
  },
  input: {
    borderWidth: 1,
    borderColor: 'grey',
    padding: 5,
    paddingLeft: 30,
    borderRadius: 0,
    marginTop: 5,
    marginBottom: 10,
    flex: 1,
    color: '#152B61',
  },
  linkIcon: {
    position: 'absolute',
    width: 20,
    height: 30,
    top: 5,
    left: 5,
  },
  urlContainer: {
    display: 'flex',
    flexDirection: 'row',
  },
});
